export function getMotorPowerFactor(
  pml: number,
  p0: number,
  p1: number,
  p2: number,
  p3: number,
  p4: number,
  p5: number,
  correction = 1
): number {
  const base =
    p0 +
    p1 * pml +
    p2 * pml * pml +
    p3 * pml * pml * pml +
    p4 * pml * pml * pml * pml +
    p5 * pml * pml * pml * pml * pml;
  return base * correction;
}

export function getMotorEfficiencyRatio(
  pml: number,
  e0: number,
  e1: number,
  e2: number,
  e3: number,
  e4: number,
  e5: number,
  correction = 1
): number {
  const base =
    e0 +
    e1 * pml +
    e2 * pml * pml +
    e3 * pml * pml * pml +
    e4 * pml * pml * pml * pml +
    e5 * pml * pml * pml * pml * pml;
  return base * correction;
}

export function getMotorCurrentA(
  motorRerateRatio: number,
  nameplateAmps: number,
  ib: number,
  i1: number,
  i2: number,
  i3: number,
  i4: number,
  i5: number,
  correction = 1
): number {
  return (
    (ib +
      i1 * motorRerateRatio +
      i2 * motorRerateRatio ** 2 +
      i3 * motorRerateRatio ** 3 +
      i4 * motorRerateRatio ** 4 +
      i5 * motorRerateRatio ** 5) *
    nameplateAmps *
    correction
  );
}

export function getMotorRerateVoltage(
  nameplateVoltage: number,
  reratePercentage: number,
  rr_v0: number,
  rr_v1: number,
  rr_v2: number,
  rr_v3: number
): number {
  return (
    nameplateVoltage *
    (rr_v0 +
      rr_v1 * reratePercentage +
      rr_v2 * reratePercentage ** 2 +
      rr_v3 * reratePercentage ** 3)
  );
}

export function getMotorSpeedRPM(
  motorLoadRatio: number,
  pumpHz: number,
  nb: number,
  n1: number,
  n2: number,
  n3: number,
  n4: number,
  n5: number,
  correction = 1
): number {
  const base =
    nb +
    n1 * motorLoadRatio +
    n2 * motorLoadRatio ** 2 +
    n3 * motorLoadRatio ** 3 +
    n4 * motorLoadRatio ** 4 +
    n5 * motorLoadRatio ** 5;

  return base * (pumpHz / 60) * correction;
}

// Total BHP Required undefined hp
// Motor HP Developed undefined hp
// returns PML %
export function percent_motor_load(
  total_bhp_required: number,
  motor_hp_developed: number
): number {
  const pml = total_bhp_required / motor_hp_developed;
  return pml;
}
